import React from 'react';
import LegalPage from '../components/LegalPage';
import TerminosYCondicionesContent from '../components/TerminosYCondicionesContent';

const TerminosYCondiciones: React.FC = () => (
  <LegalPage
    title="Términos y Condiciones"
    lastUpdated="1 de octubre de 2023"
    backHref="/"
  >
    <TerminosYCondicionesContent />
  </LegalPage>
);

export default TerminosYCondiciones;
